/* Yadegari: pass permitted campaign attribution to the three booking calendars. */
(() => {
  'use strict';
  const keys = ['gclid', 'gbraid', 'wbraid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_term', 'utm_content'];
  const calendars = new Set(['1ZxCouz0fAS8hAphPK9t', 'F3jaCXH976RlpZn4y6Yg', 'Gf7EvRkmUPyzaPpt0aHy']);
  const storageKey = 'yj_booking_attribution_v1';
  const incoming = new URLSearchParams(location.search);
  let ready = false;
  let values = {};
  /* Canada needs a real "yes": marketingAllowed() alone is true before any choice when no banner applies. */
  function permitted() {
    const privacy = window.Shopify && Shopify.customerPrivacy;
    if (!privacy || !privacy.marketingAllowed()) return false;
    const region = privacy.getRegion ? privacy.getRegion() : '';
    if (region && !region.startsWith('CA')) return true;
    const consent = privacy.currentVisitorConsent ? privacy.currentVisitorConsent() : {};
    return consent.marketing === 'yes';
  }
  function apply() {
    if (!ready) return;
    const isCalendar = url => {
      const match = url.pathname.match(/^\/widget\/booking\/([^/]+)\/?$/);
      return url.origin === 'https://api.leadconnectorhq.com' && match && calendars.has(match[1]);
    };
    const hasCalendar = Array.from(document.querySelectorAll('iframe[src]')).some(frame => {
      try { return isCalendar(new URL(frame.getAttribute('src'), location.href)); } catch (_) { return false; }
    });
    if (hasCalendar && permitted() && Object.keys(values).length) {
      const parent = new URL(location.href);
      keys.forEach(key => {
        if (values[key]) parent.searchParams.set(key, values[key]);
        else parent.searchParams.delete(key);
      });
      if (parent.href !== location.href) history.replaceState(history.state, '', parent.href);
    }
    document.querySelectorAll('iframe[src], a[href]').forEach(element => {
      const attribute = element.tagName === 'IFRAME' ? 'src' : 'href';
      let url;
      try { url = new URL(element.getAttribute(attribute), location.href); } catch (_) { return; }
      const isInternalBookingLink = element.tagName === 'A' && url.origin === location.origin &&
        /\/pages\/(book-a-consultation|custom-jewelry|jewelry-repair)\/?$/.test(url.pathname);
      if (!isCalendar(url) && !isInternalBookingLink) return;
      keys.forEach(key => {
        if (values[key]) url.searchParams.set(key, values[key]);
        else url.searchParams.delete(key);
      });
      if (url.href !== element.getAttribute(attribute)) element.setAttribute(attribute, url.href);
    });
  }
  function sync() {
    ready = true;
    values = {};
    if (!permitted()) {
      try { sessionStorage.removeItem(storageKey); } catch (_) {}
      apply();
      return;
    }
    const hasIncoming = keys.some(key => incoming.has(key));
    if (hasIncoming) {
      keys.forEach(key => {
        const value = incoming.get(key);
        if (value && value.length <= 512) values[key] = value;
      });
      try { sessionStorage.setItem(storageKey, JSON.stringify(values)); } catch (_) {}
    } else {
      try {
        const saved = JSON.parse(sessionStorage.getItem(storageKey) || '{}');
        keys.forEach(key => {
          if (typeof saved[key] === 'string' && saved[key].length <= 512) values[key] = saved[key];
        });
      } catch (_) {}
    }
    apply();
  }
  document.addEventListener('DOMContentLoaded', apply, {once: true});
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('visitorConsentCollected', sync);
  if (window.Shopify && Shopify.customerPrivacy) sync();
  else if (window.Shopify && Shopify.loadFeatures) {
    Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
      if (!error) sync();
    });
  }
})();
